import { Col, Button, Row } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React from 'react'
import * as styles from './contributeAsGuestButtons.css'
import {
  getGroupDetailPageVariant,
  tracking,
} from '../../../lib/analytics/fpti'
import Events from '../../../lib/analytics/eventTags.js'
import serverData from '../../../utils/server-data'

interface Props {
  isSmallerScreen: boolean
  isActiveGroup: boolean
  handleContributeAsGuest: () => void
  handleContributeAsUser: () => void
  groupId: string
}

export const ContributeAsGuestButtons = ({
  isSmallerScreen,
  isActiveGroup,
  handleContributeAsGuest,
  handleContributeAsUser,
  groupId,
}: Props) => {
  const handleClickOnContributePayPal = () => {
    tracking(
      Events.p2p_pools_detail_contribute_with_paypal_pressed({
        source: serverData.trackingParameters.externalSource,
        page_variant: getGroupDetailPageVariant(false, false),
        pool_id: groupId,
      }),
    )
    handleContributeAsUser()
  }

  if (isSmallerScreen || !isActiveGroup) {
    return null
  }

  return (
    <Row>
      <Col xs={6}>
        <Button
          data-testid="contributeAsGuest"
          variant="secondary"
          className={styles.buttonContributeGuest}
          onClick={handleContributeAsGuest}
          role="button"
        >
          <Message id="flatProgress.contributeCard" />
        </Button>
      </Col>
      <Col xs={6}>
        <Button
          data-testid="contributePayPal"
          onClick={handleClickOnContributePayPal}
          role="button"
          className={styles.buttonContributeGuest}
        >
          <Message id="flatProgress.contributePayPal" />
        </Button>
      </Col>
    </Row>
  )
}
